import { List } from '@material-ui/core'
import React, { useEffect, useState } from 'react'

import { formatSavedLocations } from '../../../util/locationUtils'
import SavedLocationListItem from './SavedLocationListItem'

const ListLocations = ({
  defaultLocation,
  deleteUserSavedLocationStart,
  isUpdatingSavedLocation,
  savedLocations,
  updateAndSaveUserLocationStart,
  updateSavedLocationError,
  updateUserSavedLocationStart,
}) => {
  const [savedLocationForEdit, setSavedLocationForEdit] = useState()
  const formattedSavedLocations = formatSavedLocations(
    savedLocations,
    defaultLocation?.deliveryLocationId,
  )

  // If user deletes the default location, set the next first location default
  const handleDeleteLocation = location => {
    if (location.deliveryLocationId === defaultLocation.deliveryLocationId) {
      // Get the first location that is not the default location
      const firstLocation = savedLocations?.find(
        l => l.deliveryLocationId !== location.deliveryLocationId,
      )
      firstLocation && updateAndSaveUserLocationStart(firstLocation.deliveryLocationId)
    }
    deleteUserSavedLocationStart(location.savedLocationId)
  }

  useEffect(() => {
    if (!defaultLocation && savedLocations?.length > 0) {
      // If no default location exists (e.g. inactive)
      // Set the first saved location as default
      const firstLocation = savedLocations[0]
      updateAndSaveUserLocationStart(firstLocation.deliveryLocationId)
    }
  }, [defaultLocation, savedLocations, updateAndSaveUserLocationStart])

  return (
    <List>
      {formattedSavedLocations?.map(location => (
        <SavedLocationListItem
          formattedSavedLocations={formattedSavedLocations}
          handleDeleteClick={() => handleDeleteLocation(location)}
          handleEditClick={() => setSavedLocationForEdit(location.deliveryLocationId)}
          isDefault={location.deliveryLocationId === defaultLocation?.deliveryLocationId}
          isEditing={savedLocationForEdit === location.deliveryLocationId}
          isUpdatingSavedLocation={isUpdatingSavedLocation}
          key={location.deliveryLocationId}
          location={location}
          savedLocationForEdit={savedLocationForEdit}
          setSavedLocationForEdit={setSavedLocationForEdit}
          updateSavedLocationError={updateSavedLocationError}
          updateUserSavedLocationStart={updateUserSavedLocationStart}
        />
      ))}
    </List>
  )
}

export default ListLocations
